import * as React from "react";

import { Button, Input, Modal, Select } from "antd";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";
import CustomersHeader from "../../Components/Customers/CustomersHeader";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
import CustomersList from "../../Components/Customers/CustomersList";
import { Outlet, useParams } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FaPrint } from "react-icons/fa6";
import CustomersDKPrint from "./CustomersDKPrint";
import { CustomersStore } from "../../Stores/Customers/CustomersStore";
import { ImFileExcel } from "react-icons/im";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { CiSaveDown1 } from "react-icons/ci";
import formatNumberWithSpaces from "../../Components/NumberToWords/FormatNumber";
import moment from "moment";

export default function Customers() {
  // let [loading, setLoading] = React.useState(false);
  // let [data, setData] = React.useState(false);
  let [open, setOpen] = React.useState(false);
  let [openCustomers, setOpenCustomers] = React.useState(null);
  let [openCustomersList, setOpenCustomersList] = React.useState(null);
  let [filterValues, setFilterValues] = React.useState({
    status: null,
    value: null,
    tashrif: null,
  });
  const { id } = useParams();
  const [isList, setIsList] = React.useState(false);
  let elementRef = React.useRef();

  const handlePrint = () => {
    const printContent = elementRef.current;
    const WinPrint = window.open("", "", "width=900,height=900");
    // WinPrint.document.write("<html><head><title>Print</title>");
    // WinPrint.document.write(
    //   ""
    // );
    // WinPrint.document.write("</head><body>");
    WinPrint.document.write(printContent.innerHTML);
    // WinPrint.document.write("</body></html>");
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  };

  const { fetchData, searchCustomers } = CustomersStore();

  let getAll = async () => {
    const { data } = await axiosInstance.get(
      "/api/customers/filter/by_dk?offset=0&limit=100000"
    );
    console.log(data?.data);
    setOpenCustomers(data?.data);
    setOpenCustomersList(data?.data);
  };
  React.useEffect(() => {
    if (open) {
      getAll();
    }
  }, [open]);

  // { value: "All", label: "Jami" },
  // { value: "Qarzdorlar", label: "Qarzdorlar" },
  // { value: "Xaqdorlar", label: "Xaqdorlar" },
  // { value: "Nollar", label: "Nollar", disabled: false },

  React.useEffect(() => {
    let list = [...(openCustomersList ? [...openCustomersList] : [])];

    if (!filterValues?.value && !filterValues?.status) return;

    if (filterValues?.value === "All") {
      list = [...list];
    }

    if (filterValues?.value === "Qarzdorlar") {
      list = [
        ...list.filter((el) => {
          if (el.total_sum > 0) {
            return el;
          }
        }),
      ];
    }

    if (filterValues?.value === "Nollar") {
      list = [
        ...list.filter((el) => {
          if (el.total_sum == 0) {
            return el;
          }
        }),
      ];
    }
    if (filterValues?.value === "Xaqdorlar") {
      list = [
        ...list.filter((el) => {
          if (el.total_sum < 0) {
            return el;
          }
        }),
      ];
    }

    // tashrif
    const today = moment();
    if (filterValues?.tashrif === "Hafta") {
      list = [
        ...list.filter((el) => {
          const date = moment(el?.last_access_times[0], "DD-MM-YYYY");
          const diffDays = date.diff(today, "days");
          if (Math.abs(diffDays) <= 7) {
            console.log(el);
            return el;
          }
        }),
      ];
    }
    if (filterValues?.tashrif === "Oy") {
      list = [
        ...list.filter((el) => {
          const date = moment(el?.last_access_times[0], "DD-MM-YYYY");
          const diffDays = date.diff(today, "days");
          if (Math.abs(diffDays) <= 31) {
            console.log(el);
            return el;
          }
        }),
      ];
    }
    if (filterValues?.tashrif === "Yil") {
      list = [
        ...list.filter((el) => {
          const date = moment(el?.last_access_times[0], "DD-MM-YYYY");
          const diffDays = date.diff(today, "days");
          if (Math.abs(diffDays) <= 366) {
            console.log(el);
            return el;
          }
        }),
      ];
    }

    // status filter
    if (filterValues?.status === "Status" || !filterValues?.status) {
      list = [
        ...list.filter((el) => {
          return el;
        }),
      ];
    } else {
      console.log([
        ...list.filter((el) => {
          if (el?.type == filterValues?.status) {
            return el;
          }
        }),
      ]);
      list = [
        ...list.filter((el) => {
          if (el?.type == filterValues?.status) {
            return el;
          }
        }),
      ];
    }

    console.log(list);
    setOpenCustomers([...list]);
  }, [filterValues]);

  React.useEffect(() => {
    fetchData();
  }, []);

  // dowload into excel file
  const downloadExcel = (data) => {
    // Data starts from row 4 to leave space for complex headers
    const info = [
      ...[...data]?.map((el, i) => {
        return [
          el?.id,
          el?.name,
          el?.customer_id,
          el?.phone,
          el?.INN,
          el?.total_sum,
          el?.type,
          el?.written_by,
          el?.status,
          el?.comment,
        ];
      }),

      // Add more data rows as needed
    ];

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet([
      ["", "", "", "", "", "", "", ""], // Empty row for spacing
      ["", "", "", "", "", "", "", ""], // Empty row for spacing

      [
        "№",
        "Номи",
        "Customer ID",
        "Phone",
        "INN",
        "Summa",
        "type",
        "Yozdi",
        "Status",
        "Izox",
      ], // Header row 2
      ...info, // Data rows
    ]);

    // Apply font style to the entire sheet
    const range = XLSX.utils.decode_range(ws["!ref"]); // Get the range of the sheet
    for (let R = range.s.r; R <= range.e.r; ++R) {
      // Loop through rows
      for (let C = range.s.c; C <= range.e.c; ++C) {
        // Loop through columns
        const cell_address = { c: C, r: R };
        const cell_ref = XLSX.utils.encode_cell(cell_address);

        if (!ws[cell_ref]) continue; // Skip if cell is undefined

        ws[cell_ref].s = {
          font: {
            name: "Arial Cyr", // Apply Calibri font
            sz: 9, // Font size 12
            color: { rgb: "000000" }, // Dark grey text
          },
          alignment: {
            horizontal: "center", // Center horizontally
            vertical: "center", // Center vertically
          },
        };
      }
    }

    // Create workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate buffer and save
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, "Ro'yxat.xlsx");
  };
  return (
    <div>
      {/* <CustomersHeader /> */}

      <div className=" flex flex-row">
        <div
          className={
            id
              ? "h-screen overflow-auto w-[100%]  top-0 z-10 flex flex-col gap-2 bg-white scrollbar-hidden"
              : "hidden md:block h-screen overflow-auto w-[100%]  top-0 z-10 flex flex-col gap-2 bg-white scrollbar-hidden"
          }
        >
          <Outlet />
        </div>
        <div
          style={{ resize: "both", display: isList ? "none" : "" }}
          className={
            id
              ? "scrollbar-hidden hidden md:block h-screen overflow-auto w-[100%] md:max-w-[350px] pb-4 border-[1px] border-[#bfbfbf] relative"
              : "scrollbar-hidden md:block h-screen overflow-auto w-[100%] md:max-w-[350px] pb-4 border-[1px] border-[#bfbfbf] relative "
          }
        >
          <div className="z-50 w-[100%] px-2 border-b-[1px] border-b-[#bfbfbf] flex flex-row items-center sticky top-0 bg-[#fff] pt-2">
            <CustomersHeader />
          </div>
          <div
            className={`z-50 transition-all duration-300  flex flex-row items-center justify-center p-2 sticky top-[47px] bg-[#fff] gap-1 `}
          >
            <Input
              className="text-[16px]"
              loading={true}
              onKeyDown={(e) => {
                console.log(e);
                if (e.key == "Enter") {
                  if (e.target.value.length > 0) {
                    searchCustomers(e.target.value);
                  } else {
                    fetchData();
                  }
                }
              }}
              prefix={<IoIosSearch className="font-[30px]" />}
              onChange={(e) => {
                if (e.target.value.length > 0) {
                  searchCustomers(e.target.value);
                } else {
                  fetchData();
                }
              }}
              type="search"
              placeholder="Qidirish..."
            />{" "}
            <Button
              onClick={() => {
                setOpen(true);
              }}
              icon={<IoDocumentTextOutline className="font-[30px]" />}
            ></Button>
            <Modal
              style={{ top: "40px", width: "900px" }}
              title="Qarz yoki Xaqdorlik"
              open={open}
              width={800}
              //   loading={loadVagon}
              onOk={() => {
                setOpen(false);
              }}
              onCancel={() => {
                console.log("Modal closed via Cancel button or close icon.");
                setOpen(false);
              }}
              footer={[]}
            >
              <div className="flex flex-row justify-between items-center">
                <div className="flex gap-2">
                  <Select
                    disabled={openCustomers ? false : true}
                    defaultValue="Jami"
                    style={{ width: 120 }}
                    onChange={(value) => {
                      setFilterValues({ ...filterValues, value: value });
                    }}
                    options={[
                      { value: "All", label: "Jami" },
                      { value: "Qarzdorlar", label: "Qarzdorlar" },
                      { value: "Xaqdorlar", label: "Xaqdorlar" },
                      { value: "Nollar", label: "Nollar", disabled: false },
                    ]}
                  />
                  <Select
                    disabled={openCustomers ? false : true}
                    defaultValue="Tashriflar"
                    style={{ width: 120 }}
                    onChange={(value) => {
                      setFilterValues({ ...filterValues, tashrif: value });
                    }}
                    options={[
                      { value: "Tashriflar", label: "Tashriflar" },
                      { value: "Hafta", label: "1 hafta" },
                      { value: "Oy", label: "1 Oy" },
                      { value: "Yil", label: "1 Yil", disabled: false },
                    ]}
                  />
                  <Select
                    disabled={openCustomers ? false : true}
                    defaultValue="Status"
                    style={{ width: 120 }}
                    onChange={(value) => {
                      setFilterValues({ ...filterValues, status: value });
                    }}
                    options={[
                      { value: "Status", label: "Status" },
                      { value: "MCHJ / FX", label: "MCHJ / FX" },
                      { value: "Shaxobcha", label: "Shaxobcha" },
                      { value: "Shaxs", label: "Shaxs" },
                      { value: "Brokker", label: "Brokker" },
                      { value: "Do'kon", label: "Do'kon", disabled: false },
                    ]}
                  />
                </div>
                <div className="flex gap-2">
                  <Button
                    disabled={openCustomers ? false : true}
                    onClick={() => {
                      handlePrint();
                    }}
                    variant="solid"
                    icon={<FaPrint className="font-[30px]" />}
                  ></Button>
                  <Button
                    disabled={openCustomers ? false : true}
                    onClick={() => {
                      downloadExcel(openCustomers);
                    }}
                    variant="solid"
                    icon={<ImFileExcel className="font-[30px]" />}
                  ></Button>
                </div>
              </div>
              <div className="flex flex-row items-center justify-between p-1">
                <h2 className="text-[16px]">
                  Qarzdorlik:{" "}
                  {formatNumberWithSpaces(
                    openCustomers
                      ?.reduce((acc, curr) => {
                        if (Number(curr?.total_sum) > 0) {
                          return acc + Number(curr?.total_sum);
                        }
                        return acc + 0;
                      }, 0)
                      ?.toFixed(2)
                  )}{" "}
                </h2>
                <h2 className="text-[16px]">
                  Xaqdorlik:{" "}
                  {formatNumberWithSpaces(
                    openCustomers
                      ?.reduce((acc, curr) => {
                        if (Number(curr?.total_sum) < 0) {
                          return acc + Number(curr?.total_sum);
                        }
                        return acc + 0;
                      }, 0)
                      ?.toFixed(2)
                  )}{" "}
                </h2>
              </div>
              <div ref={elementRef}>
                <div style={{ margin: "20px" }}>
                  <CustomersDKPrint data={openCustomers} />
                </div>
              </div>
            </Modal>
          </div>

          <CustomersList />
        </div>
      </div>
    </div>
  );
}
